import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import ErrorBoundary from '../components/ErrorBoundary';

import CuisineCardsSelector from '../components/CuisineCardsSelector';
import DietCardsSelector from '../components/DietCardsSelector';
import FoodTypeCardsSelector from '../components/FoodTypeCardsSelector';
import TagCardsSelector from '../components/TagCardSelector';

const ExploreRecipesPage = () => {
    const navigate = useNavigate();
    const { pgUser, sessionToken } = useAuth();
    const [isAuthLoading, setIsAuthLoading] = useState(true);



    // Handle auth loading state
    useEffect(() => {
        if (pgUser === null) {
            setIsAuthLoading(false);
            return;
        }
        setIsAuthLoading(false);
    }, [pgUser]);

    return (
        <ErrorBoundary fallbackMessage="Unable to load recipes explorer. Please try again later.">
            <div className="container">
                {isAuthLoading ? (
                    <div className="text-center my-4">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : !pgUser ? (
                    <div className="alert alert-warning">
                        <p className="h5 mb-3">Unable to connect to the server. Please try again later or send a message to <a href="mailto:support@getautochef.com">support@getautochef.com</a></p>
                        <Button onClick={() => window.location.reload()}>Retry</Button>
                    </div>
                ) : (
                    <>
                        <h1 className='mb-3'><b>Explore Recipes</b></h1>
                        
                        {(!pgUser.setup_complete) && (
                            <div className="alert alert-warning mb-4">
                                <p className="h5 mb-3">Complete meal preferences to start exploring recipes!</p>
                                <Button onClick={() => navigate('/setup')}>Complete Setup</Button>
                            </div>
                        )}

                        {pgUser.setup_complete && (
                            <>
                                <div className="d-flex flex-wrap gap-2 mb-3 justify-content-center">
                                    <Link to="/recipes/all">
                                        <button className="all-recipes-btn">All Recipes</button>
                                    </Link>
                                    <Link to="/recipes/saved">
                                        <button className="all-recipes-btn">My Recipes</button>
                                    </Link>
                                    <Link to="/recipes/search-by-ingredients">
                                        <button className="all-recipes-btn">Search by Ingredients</button>
                                    </Link>
                                </div>
                                <div className="section mb-4">
                                    <h2 className=" mt-4 mb-0">Diets</h2>
                                    <ErrorBoundary 
                                        fallbackMessage={
                                            <div className="alert alert-warning">
                                                <p>Unable to load diet options. Please try refreshing the page.</p>
                                                <Button size="sm" onClick={() => window.location.reload()}>
                                                    Refresh Page
                                                </Button>
                                            </div>
                                        }
                                    >
                                        <DietCardsSelector sessionToken={sessionToken} />
                                    </ErrorBoundary>
                                </div>

                                <div className="section mb-4">
                                    <h2>Cuisines</h2>
                                    <ErrorBoundary 
                                        fallbackMessage={
                                            <div className="alert alert-warning">
                                                <p>Unable to load cuisine options. Please try refreshing the page.</p>
                                                <Button size="sm" onClick={() => window.location.reload()}>
                                                    Refresh Page
                                                </Button>
                                            </div>
                                        }
                                    >
                                        <CuisineCardsSelector sessionToken={sessionToken} />
                                    </ErrorBoundary>
                                </div>

                                <div className="section mb-4">
                                    <h2 className="mb-0">Food Types</h2>
                                    <ErrorBoundary 
                                        fallbackMessage={
                                            <div className="alert alert-warning">
                                                <p>Unable to load food type options. Please try refreshing the page.</p>
                                                <Button size="sm" onClick={() => window.location.reload()}>
                                                    Refresh Page
                                                </Button>
                                            </div>
                                        }
                                    >
                                        <FoodTypeCardsSelector sessionToken={sessionToken} />
                                    </ErrorBoundary>
                                </div>

                                <div className="section mb-4">
                                    <h2 className="mb-0">More</h2>
                                    <ErrorBoundary 
                                        fallbackMessage={
                                            <div className="alert alert-warning">
                                                <p>Unable to load tag options. Please try refreshing the page.</p>
                                                <Button size="sm" onClick={() => window.location.reload()}>
                                                    Refresh Page
                                                </Button>
                                            </div>
                                        }
                                    >
                                        <TagCardsSelector sessionToken={sessionToken} />
                                    </ErrorBoundary>
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
        </ErrorBoundary>
    );
};

export default ExploreRecipesPage;